export const questions = [
  {
    questions: [
      {
        answer:
          'Зарегистрируйтесь, оформите в личном кабинете профиль эксперта, заключите с нами договор по \nSMS (ничего подписывать не надо!), консультируйте и зарабатывайте.',
        question: 'Как стать экспертом Consulty?',
      },
      {
        answer:
          'Подписывать ничего не нужно. Нужно будет подтвердить договор по SMS. Он формируется после заполнения необходимой информации в личном кабинете. Этого достаточно, чтобы работать с сервисом и выводить заработанные деньги на законных основаниях без вопросов от налоговой 👌🏻',
        question: 'Мне нужно подписывать какие-нибудь документы?',
      },
      {
        answer:
          'Для этого в Consulty есть мессенджер. В нем вы можете отправлять текстовые и аудиосообщения, \nприкреплять файлы и обмениваться с пользователем контактами. А еще через мессенджер можно \nпредложить платную услугу. ',
        question: 'Как проводить консультации?',
      },
      {
        answer:
          'Консультация длится 1 час или меньше, если эксперт отправил 20 сообщений. Любую\n консультацию можно продлить платно или бесплатно по желанию эксперта.',
        question: 'Сколько длится консультация?',
      },
      {
        answer:
          'Вы сами устанавливаете цену консультации. Если хотите больше консультаций и отзывов, \nустановите невысокую. Если у вас солидный опыт и много отзывов, то устанавливайте выше. \n\n Consulty берет комиссию — 9%, 14,9% или 19,9% с консультации в зависимости от тарифа. \nОстальную сумму полностью получаете вы.',
        question: 'Сколько стоят консультации? ',
      },
      {
        answer:
          'Раз в сутки на привязанную карту будет автоматически переводиться сумма от 2000 рублей. Если \nхотите вывести сумму меньше, напишите в поддержку: чат справа внизу, <a href="mailto:${SUPPORT_EMAIL}">support@consulty.online</a> \nили <a href="https://t.me/consultyonline">Telegram</a>. В этом случае вывод может занять до 5 дней. \n\nВнимание! Consulty работает только с картами российских банков. Нельзя вывести деньги \nна электронный кошелек или карту иностранного банка.',
        question: 'Как вывести деньги?',
      },

      {
        answer:
          'Если коллеги и знакомые иногда обращаются к вам за советом по работе, считайте, что он у вас \nесть. Если нет — не страшно. Воспользуйтесь подсказками в <a href="/app/academy"> Академии экспертов</a> после \nрегистрации.',
        question: 'Если у меня нет опыта в консультациях? ',
      },

      {
        answer:
          'Consulty берет комиссию — 9%, 14,9% или 19,9% с каждой консультации в зависимости от тарифа. \nОб условиях получения сниженных тарифов читайте на странице <a href="/expert">Стать экспертом</a> или спросите \nнас в <a href="https://t.me/consultyonline">Telegram</a>, чате справа внизу или на <a href="mailto:${SUPPORT_EMAIL}">support@consulty.online</a>.',
        question: 'На чем зарабатывает ваш сервис?',
      },

      {
        answer:
          'Люди, которым нужна консультация, находят Consulty через рекламу в интернете. Вам остается \nзаинтересовать их своим рейтингом и условиями консультаций. Реагируйте на вопросы быстрее \nдругих или консультируйте дешевле. Проводите хорошие консультации, для этого воспользуйтесь \nподсказками нашей <a href="/app/academy"> Академии экспертов</a> после регистрации.\n\nВы также можете привлечь больше пользователей на сервис. Расскажите о вашем профиле \nConsulty в соцсетях или блоге.  Просто поделитесь своим профилем эксперта в соцсетях, блоге или \nна сайте.',
        question: 'Как привлекать больше клиентов на консультации?',
      },

      {
        answer: 'Вы получаете уведомления по всем новым вопросам, но сами выбираете, на какие из них ответить.',
        question: 'Если обратятся с вопросом, на который я не хочу отвечать?',
      },

      {
        answer:
          'Да, для этого в Consulty есть отдельная функция. Вы сможете предложить услугу прямо во время \nконсультации.',
        question: 'Можно ли предлагать дополнительные услуги?',
      },

      {
        answer: 'Да, в мессенджере для консультаций вы можете отправить свои контакты, ссылку на сайт или соцсети.',
        question: 'Можно обмениваться контактами с клиентами?',
      },

      {
        answer:
          'У нас есть приложение. В нём можно отслеживать заявки на консультации и консультировать, но \nчтобы зарегистрировать профиль эксперта, нужно зарегистрироваться в веб-версии Consulty.',
        question: 'Мне нужно сидеть постоянно у компьютера, чтобы отслеживать заявки на консультации?',
      },

      {
        answer:
          'Напишите нам на <a href="mailto:${SUPPORT_EMAIL}">support@consulty.online</a> или воспользуйтесь специальной формой «Не нашли нужную тему?» на <a href="https://www.consulty.online/app/topics">странице тем</a> или в <a href="https://www.consulty.online/app/profile?activeTab=expertProfile">личном кабинете</a>, в самом низу. Мы всегда рады добавить востребованную тему на Consulty.',
        question: 'Нет нужной мне темы для консультаций, как быть?',
      },
      {
        answer:
          'Напишите нам в <a href="https://t.me/consultyonline">Telegram</a>, чат справа внизу или на <a href="mailto:${SUPPORT_EMAIL}">support@consulty.online</a>.',
        question: 'У меня другой вопрос',
      },
    ],
  },
];
